export default "__VITE_ASSET__aoVMEksi__"